import React from "react";
import PageHeaderWrapper from "../../components/PageHeaderWrapper";
import { connect } from "react-redux";
import { Card, Row, Col, Select, DatePicker } from "antd";
import Request from "../../request";
import moment from "moment";
import { TableComp } from "sz-react-utils";

const { Option } = Select;
const { MonthPicker } = DatePicker;

class StudentRecruitmentMetricsReport extends React.Component {
    state = {
        lastSixYears: [],
        countriesArr: [],
        year: null,
        dateFilter: null,
        countryId: null,
        dataSource: [],
        loading: false,
    };

    constructor(props) {
        super(props);
        this.table = React.createRef();
    }

    componentDidMount() {
        this.loadCountries();
        const currentYear = new Date().getFullYear();
        const lastSixYears = Array.from({ length: 6 }, (_, i) => currentYear - i);
        this.setState({ lastSixYears });
    }

    loadCountries = async () => {
        try {
            let params = {
                results: 10000,
                count: 10000,
            };
            let { data } = await Request.getCountriesWithoutAuth(params);
            this.setState({ countriesArr: data });
        } catch (error) {
            console.error("Error loading countries:", error);
        }
    };

    loadApi = async () => {
        this.setState({ loading: true });
        let { dateFilter, countryId, year } = this.state;

        // If no dateFilter but year is selected
        if (!dateFilter && year) {
            dateFilter = {
                $gte: moment(year, "YYYY").startOf("year").toDate(),
                $lte: moment(year, "YYYY").endOf("year").toDate(),
            };
        }

        let params = {
            dateFilter: dateFilter,
            countryId: countryId,
        };

        try {
            let response = await Request.getStudentRecruitmentMetrics(params);
            const { data } = response;

            // Convert the nested object into an array for the table
            const dataSource = Object.values(data).map((item) => ({
                key: item.universityId,
                universityName: item.universityDetails[0],
                count: item.count,
            }));

            this.setState({ dataSource, loading: false });
        } catch (error) {
            console.error("Error fetching data:", error);
            this.setState({ loading: false });
        }
    };

    handleDateChange = (value, filterName) => {
        let { year } = this.state;
        let dateFilter = null;

        // Filter By Half Year
        if (filterName === "halfYear") {
            if (value === "First Half Year") {
                dateFilter = {
                    $gte: year
                        ? moment(year, "YYYY").startOf("year").toDate()
                        : moment().startOf("year").toDate(),
                    $lte: year
                        ? moment(year, "YYYY")
                              .startOf("year")
                              .add(5, "months")
                              .endOf("month")
                              .toDate()
                        : moment()
                              .startOf("year")
                              .add(5, "months")
                              .endOf("month")
                              .toDate(),
                };
            } else if (value === "Second Half Year") {
                dateFilter = {
                    $gte: year
                        ? moment(year, "YYYY")
                              .startOf("year")
                              .add(6, "months")
                              .toDate()
                        : moment()
                              .startOf("year")
                              .add(6, "months")
                              .toDate(),
                    $lte: year
                        ? moment(year, "YYYY").endOf("year").toDate()
                        : moment().endOf("year").toDate(),
                };
            }
        }

        // Filter By Quarter
        if (filterName === "quarter") {
            const startOfQuarterMap = {
                "First Quarter": 0,
                "Second Quarter": 3,
                "Third Quarter": 6,
                "Fourth Quarter": 9,
            };
            if (value) {
                const startMonth = startOfQuarterMap[value];
                dateFilter = {
                    $gte: year
                        ? moment(year, "YYYY")
                              .startOf("year")
                              .add(startMonth, "months")
                              .toDate()
                        : moment()
                              .startOf("year")
                              .add(startMonth, "months")
                              .toDate(),
                    $lte: year
                        ? moment(year, "YYYY")
                              .startOf("year")
                              .add(startMonth + 2, "months")
                              .endOf("month")
                              .toDate()
                        : moment()
                              .startOf("year")
                              .add(startMonth + 2, "months")
                              .endOf("month")
                              .toDate(),
                };
            }
        }

        // Filter By Month
        if (filterName === "month") {
            dateFilter = {
                $gte: moment(value, "YYYY-MM").startOf("month").toDate(),
                $lte: moment(value, "YYYY-MM").endOf("month").toDate(),
            };
        }

        if (value === null) {
            dateFilter = null;
        }

        this.setState({ dateFilter, countryId: null });
    };

    render() {
        let { lastSixYears, dateFilter,countryId, countriesArr, year, dataSource, loading } =
            this.state;
        const columns = [
            {
                title: "University Name",
                dataIndex: "universityName",
                key: "universityName",
            },
            {
                title: "Count",
                dataIndex: "count",
                key: "count",
            },
        ];

        return (
            <PageHeaderWrapper title="Student Recruitment Metrics Report">
                <Card bordered={true}>
                    <Row gutter={[16, 16]}>
                        <Col span={6}>
                            <label>Search By Year</label>
                            <Select
                                style={{ width: "100%" }}
                                placeholder="Select year"
                                onChange={(year) =>
                                    this.setState({ year, countryId: null })
                                }
                            >
                                {lastSixYears.map((year) => (
                                    <Option key={year} value={year}>
                                        {year}
                                    </Option>
                                ))}
                            </Select>
                        </Col>
                        <Col span={6}>
                            <label>Search By Half Yearly</label>
                            <Select
                                style={{ width: "100%" }}
                                placeholder="Select half year"
                                onChange={(value) =>
                                    this.handleDateChange(value, "halfYear")
                                }
                            >
                                <Option value="First Half Year">
                                    First Half Year
                                </Option>
                                <Option value="Second Half Year">
                                    Second Half Year
                                </Option>
                            </Select>
                        </Col>
                        <Col span={6}>
                            <label>Search By Quarter</label>
                            <Select
                                style={{ width: "100%" }}
                                placeholder="Select quarter"
                                onChange={(value) =>
                                    this.handleDateChange(value, "quarter")
                                }
                            >
                                <Option value="First Quarter">
                                    First Quarter
                                </Option>
                                <Option value="Second Quarter">
                                    Second Quarter
                                </Option>
                                <Option value="Third Quarter">
                                    Third Quarter
                                </Option>
                                <Option value="Fourth Quarter">
                                    Fourth Quarter
                                </Option>
                            </Select>
                        </Col>
                        <Col span={6}>
                            <label>Search By Month</label>
                            <MonthPicker
                                style={{ width: "100%" }}
                                placeholder="Select month"
                                onChange={(date) =>
                                    this.handleDateChange(date, "month")
                                }
                            />
                        </Col>
                    </Row>
                </Card>
                {(dateFilter || year) && (
                    <Card>
                        <Row gutter={16}>
                            <Col span={6}>
                                <label>Search By Country</label>
                                <Select
                                    value={this.state.countryId}
                                    style={{ width: "100%" }}
                                    showSearch
                                    placeholder="Select Country"
                                    onChange={(value) =>
                                        this.setState({ countryId: value }, () => {
                                            this.loadApi();
                                        })
                                    }
                                >
                                    {countriesArr.map((country) => (
                                        <Option key={country._id} value={country._id}>
                                            {country.countryName}
                                        </Option>
                                    ))}
                                </Select>
                            </Col>
                        </Row>
                    </Card>
                )}
                {(dateFilter && countryId) || (year && countryId)?
                <Card loading={loading}>
                    <TableComp
                        dataSource={dataSource}
                        columns={columns}
                        pagination={false}
                    />
                </Card>
                :null}
            </PageHeaderWrapper>
        );
    }
}

const mapStateToProps = ({ global }) => ({
    categories: global.categories,
});

export default connect(mapStateToProps)(StudentRecruitmentMetricsReport);
